module.exports = __webpack_public_path__ + "img/suport.eb6635ca.png";